import { Injectable, inject } from '@angular/core';
import { environment } from '@fitness-force/environments';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConflictError, AppErrors, NotFoundError } from '@fitness-force/models';;
import type { PlanBreakUpCalculationResponse, StaffDiscountCalculationRequest, UpgradePlanBreakUpRequest, UpgradePlanBreakUpResponse } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class UpgradeService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  UpgradeCalculation(tenantId: number, client_id:number, subscriptionId: number,data:UpgradePlanBreakUpRequest):Observable<PlanBreakUpCalculationResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.UPGRADE_CALCULATION
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{subscription_id}', subscriptionId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getUpgradeStaffDiscountCalculation(tenant_id: number, subscription_plan_id: number, staffDiscountCalculationRequest: StaffDiscountCalculationRequest)
    : Observable<PlanBreakUpCalculationResponse> {
    return this.http
      .post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.UPGRADE_STAFF_DISCOUNT_CALCULATION
        .replace('{tenant_id}', tenant_id.toString())
        .replace('{plan_id}', subscription_plan_id.toString())
        , staffDiscountCalculationRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
